var _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFacebook = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12c0 -6.628 -5.372 -12 -12 -12S0 5.372 0 12c0 5.989 4.387 10.954 10.125 11.854V15.469H7.078V12H10.125v-2.644c0 -3.007 1.792 -4.669 4.532 -4.669 1.313 0 2.686 0.235 2.686 0.235V7.875h-1.513c-1.491 0 -1.956 0.925 -1.956 1.874V12h3.329l-0.532 3.469H13.875v8.385C19.612 22.955 24 17.989 24 12Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.671 15.469 0.532 -3.469H13.875v-2.251c0 -0.95 0.465 -1.875 1.956 -1.875h1.513V4.922s-1.373 -0.234 -2.686 -0.234c-2.74 0 -4.532 1.661 -4.532 4.669V12H7.078v3.469H10.125v8.385a12.091 12.091 0 0 0 3.75 0v-8.385h2.796Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook.eb254634.svg";
export { ForwardRef as ReactComponent };